import { onBeforeUnmount, onMounted, ref } from 'vue';

export const useMouseIdle = (targetRef, delay) => {
  const isIdle = ref(false);
  let timerId = null;

  const handleMouseMove = () => {
    isIdle.value = false;
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      isIdle.value = true;
    }, delay);
  };

  onMounted(() => {
    targetRef.value?.addEventListener('mousemove', handleMouseMove);
    handleMouseMove();
  });

  onBeforeUnmount(() => {
    targetRef.value?.removeEventListener('mousemove', handleMouseMove);
    clearTimeout(timerId);
  });

  return { isIdle };
};
